'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import useInterval from "@/lib/hooks/useInterval";

import { useIdentity } from '@/lib/hooks/useIdentity';
import { adsReady as adsReadyAtom } from '@/lib/atoms/ads-ready';
import { GPT_STANDARD_URL } from '@/lib/constants';

const turnOnAds = () => {
  if (window.googletag && googletag.apiReady) {
    googletag.cmd.push(() => {
      // Disable initial load, to precisely control when ads are requested.
      googletag.pubads().disableInitialLoad();

      // Enable SRA and services.
      googletag.pubads().enableSingleRequest();
      googletag.enableServices();
    });
  }
}

if (typeof window !== 'undefined') {
  // Ensure we can interact with the GPT command array.
  window.googletag = window.googletag || { cmd: [] };
}

interface InitializeGPTProps {
  call_sign?: string;
  ketchHeadEnabled: boolean;
}

const InitializeGPT = (props: InitializeGPTProps) => {
  const { call_sign, ketchHeadEnabled } = props;
  const { isSignedIn, cachedIdentity } = useIdentity();
  const [ adsTurnedOn, setAdsTurnedOn ] = useState(false);
  const [adsReady, setAdsReady] = useAtom(adsReadyAtom)

  useInterval(() => {
    if(window.googletag && googletag.apiReady && !adsTurnedOn) {
      setAdsReady(true)
    }
  }, 100)

  useEffect(() => {
    if (window.googletag && googletag.apiReady && !adsTurnedOn && adsReady) {
      // Add custom targeting parameters.

      // first, is the user signed in?
      googletag.pubads().setTargeting('pbsuser', isSignedIn ? 'yes' : 'no');

      // second, is the user a passport user?
      let passportStatus;
      switch(true) {
        case !isSignedIn:
          passportStatus = 'loggedout';
          break;
        case cachedIdentity?.isPassport === true:
          passportStatus = 'yes';
          break;
        default:
          passportStatus = 'no';
      }

      googletag.pubads().setTargeting('passport', passportStatus);

      // third, what station are they localzied to (as a callsign)?
      if (call_sign) {
        googletag.pubads().setTargeting('station', call_sign.toLowerCase());
      }

      turnOnAds();
      setAdsTurnedOn(true);
    }
  }, [isSignedIn, cachedIdentity, call_sign, adsTurnedOn, adsReady]);

  return (
    <script
      type={ ketchHeadEnabled ? "text/plain" : undefined }
      data-ketch-id="ketch-doubleclick-gpt"
      data-purposes="behavioral_advertising"
      defer
      src={GPT_STANDARD_URL}
    />
  );
}

export default InitializeGPT;
